<template>
	<FABDialog
		ref="archive"
		color="secondary"
		tooltip="View Archived Reports"
		icon="unarchive"
	>
		<template slot="dialog">
			<v-container>
				<v-layout row>
					<v-flex class="text-xs-center">
						<h1
							v-if="archivedReports.length > 0"
							class="headline"
						>
							Archived Reports
						</h1>
						<h1
							v-else
							class="title"
						>
							No Archived Reports
						</h1>
					</v-flex>
				</v-layout>
				<v-layout
					row
					wrap
				>
					<v-flex
						v-for="item in archivedReports.models"
						:key="item.id"
						xs12
						sm6
						pa-2
					>
						<v-card
							class="pa-2 archived-report-card"
						>
							<v-layout
								row
								align-center
							>
								<v-flex xs6>
									<div class="subheading pl-3">
										{{ item.displayName }}
										<span
											v-if="item.date"
											class="caption"
										>
											- {{ item.date }}
										</span>
									</div>
								</v-flex>
								<v-spacer/>
								<v-btn
									:to="{ name: 'ArticlesList', params: { reportId: item.id } }"
									flat
								>
									View
								</v-btn>
								<v-btn
									v-if="$userCan('manage_reports')"
									flat
									color="success"
									@click="restoreReport(item)"
								>
									Restore
								</v-btn>
							</v-layout>
							<div
								v-if="item.saving"
								class="loading-overlay"
							>
								<v-progress-circular
									indeterminate
									color="primary"
								/>
							</div>
						</v-card>
					</v-flex>
				</v-layout>
			</v-container>
		</template>
	</FABDialog>
</template>

<script>
import FABDialog from '@/components/FABDialog';

export default {
	components: {
		FABDialog,
	},
	created() {
		this.archivedReports.models.sort((a, b) => a.displayName.localeCompare(b.displayName));
	},
	computed: {
		archivedReports() {
			return this.$store.get('reports/archived');
		},
	},
	methods: {
		restoreReport(report) {
			report.isArchived = false;
			report.save().then(() => {
				this.$store.dispatch('reports/restore', report);
				this.$notify('success', `"${report.displayName}" has been restored.`);
			}).catch((e) => {
				dump('Error restoring report', e);
				this.$notify('error', 'Failed to restort report.');
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.archived-report-card {
	position: relative;
}
.loading-overlay {
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(255, 255, 255, 0.8);
	display: flex;
	justify-content: center;
	align-items: center;
}
</style>
